import React from 'react';
import { createRoot } from 'react-dom/client';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import BulkPurchaseContainer from './BulkPurchaseContainer';

const { stripePublicKey } = window.bulkPurchaseCodeCheckoutFlow;
const stripePromise = loadStripe(stripePublicKey);

const App = () => {
  return (
    <Elements stripe={stripePromise}>
      {/*
        We need to place the Elements component wrapping any code that might access
        the Elements API. In this case, the BulkPurchaseContainer uses the Elements
        API in the handleCheckoutClick method
      */}
      <BulkPurchaseContainer />
    </Elements>
  );
};

const container = document.getElementById('bulkpurchasecode-checkout-flow-mountpoint');
const root = createRoot(container);
root.render(<App />);
